import React from 'react';
import PropTypes from 'prop-types';
import Table from '@/modules/common/components/Table';
import TableContainer from "@/modules/common/components/TableContainer";
import TableHead from './TableHead';
import TableBody from './TableBody';

const Component = (props) =>  {
    return (
        <TableContainer responsive={true}>
            <Table>
                <TableHead/>
                <TableBody items={props.items}/>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    items: PropTypes.array,
};

export default Component;
